export enum BuilderTypes {
  banner = "banner",
  slider = "slider",
  category = "category",
  brands = "brands",
  product = "product",
  product_tabs = "product-tabs",
  service_box = "service-box",
  feature_box = "feature-box",
  gallery = "gallery",
  black_box = "black-box",
  calender = "calender",
  html_blocks = "html-blocks",
  consultation_box = "consultation-box",
  scrollable_tabs = "scrollable-tabs",
  student_tabs = "student-tabs",
  blogs = "blogs",
  event = "event",
}
export interface IBlackBox {
  index: number;
  type: BuilderTypes.black_box;
}
export enum ConfigTypes {
  grid = "grid",
  carousel = "carousel",
}
export enum Size {
  small = "small",
  large = "large",
  vertical_small = "vertical_small",
  vertical_large = "vertical_large",
}

export enum S_BContentTypes {
  custom = "custom",
  product = "product",
}
export enum TitleAlign {
  start = "start",
  center = "center",
  end = "end",
}
export const WIDTHS = {
  category: {
    circle_icon: 70, //default
    circle_icon_pc: 194, //default
    circle_img: 70,
    circle_img_pc: 194,
    square: 74,
    square_large: 96,
    square_colored_title: 86,
    square_colored_title_pc: 120,
  },
};
